export default __webpack_public_path__ + "4df4b286795c569564e63462a1bd37a2.png";